export class ExceededTotalNewParticipantsError extends Error {
  constructor(msg: string) {
    super(msg)
    Object.setPrototypeOf(this, ExceededTotalNewParticipantsError.prototype)
  }
}
